const setFieldState = ($ctx, selector, show = true, enable = true) => {
  $ctx.find(selector).toggle(show);
  $ctx.find(`${selector} select, ${selector} input`).prop("disabled", !enable);
};

const updateOptions = ($ctx) => {
  if (!$ctx.find(".variant-input-wrap").length) return;

  const variantChoices = $ctx.find(".variant-input-wrap select").toArray().map(select => select.value.toLowerCase().trim());
  const selectedVariant = variantChoices.find(value => value === "jersey" || value === "pants" || (value.includes("jersey") && value.includes("pants"))) || variantChoices[0];
  const selectedPantStyle = $ctx.find(".pant-style select").val()?.toLowerCase().trim();

  setFieldState($ctx, ".jersey-name", false, false);
  setFieldState($ctx, ".jersey-number", false, false);
  setFieldState($ctx, ".jersey-size", false, false);
  setFieldState($ctx, ".jersey-style", false, false);
  setFieldState($ctx, ".pant-size", false, false);
  setFieldState($ctx, ".jogger-size", false, false);
  setFieldState($ctx, ".pant-style", false, false);
  setFieldState($ctx, ".pant-material", false, false);

  if (selectedVariant === "jersey") {
    setFieldState($ctx, ".jersey-name");
    setFieldState($ctx, ".jersey-number");
    setFieldState($ctx, ".jersey-size");
    setFieldState($ctx, ".jersey-style");
    return;
  }

  if (selectedVariant === "pants") {
    setFieldState($ctx, selectedPantStyle === "gravity joggers" ? ".jogger-size" : ".pant-size");
    setFieldState($ctx, ".pant-style");
    setFieldState($ctx, ".pant-material");
    return;
  }

  setFieldState($ctx, ".jersey-name");
  setFieldState($ctx, ".jersey-number");
  setFieldState($ctx, ".jersey-size");
  setFieldState($ctx, ".jersey-style");
  setFieldState($ctx, selectedPantStyle === "gravity joggers" ? ".jogger-size" : ".pant-size");
  setFieldState($ctx, ".pant-style");
  setFieldState($ctx, ".pant-material");
};

const initSliders = () => {
  try {
    $(".slider-left").slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      arrows: false,
      swipe: false,
      slidesToShow: 4,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false,
      rtl: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            variableWidth: true,
            slidesToShow: 2,
          },
        },
      ],
    });
  } catch (e) {}

  try {
    $(".slider-right").slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      arrows: false,
      swipe: false,
      slidesToShow: 4,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false,
      rtl: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            variableWidth: true,
            slidesToShow: 2,
          },
        },
      ],
    });
  } catch (e) {}
};

$(document).ready(function () {
  // Run once per product form on page load
  $(".variant-input-wrap").each(function () {
    updateOptions($(this).closest("form"));
  });

  initSliders();

  $(document).on("change", ".variant-input-wrap select, .pant-style select", function () {
    updateOptions($(this).closest("form"));
  });
});

document.addEventListener("sos:product-form:ready", function (event) {
  $(event.target).find("form").each(function () { updateOptions($(this)); });
});

document.addEventListener("shopify:section:load", function () {
  $(".variant-input-wrap").each(function () {
    updateOptions($(this).closest("form"));
  });
  initSliders();
});

document.addEventListener("shopify:section:select", function () {
  $(".variant-input-wrap").each(function () {
    updateOptions($(this).closest("form"));
  });
  initSliders();
});

